import React, {useState} from "react";
import AvatarName from "../AvatarName";
import "./totalAttendees.scss";
import {Tooltip} from '@mui/material';
import AttendeeChip from "../AttendeeChip/AttendeeChip";

const TotalAttendees = ({attendees}) => {
    const names = attendees.map(({name}) => name);
    const [showAttendees, setShowAttendees] = useState(false);

    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setShowAttendees(showAttendees => !showAttendees);
    }

    const namesAttendeesChip = (<div>{names.map((name, index) => (
        <AttendeeChip name={name} index={index} key={index} noBorders={true}/>))}</div>);

    return <Tooltip open={showAttendees} title={namesAttendeesChip}
                    placement={"bottom"} classes={{tooltip: "total-attendees-tooltip"}}>
        <div className={"attendees-container"} onClick={handleClick}>
            <div className={"avatars"}> {names.map((name, index) => <AvatarName name={name} overlap={true} index={index}
                                                                                key={index}/>)}</div>
            <p className={"attendees"}>{`${names.length} attendees`}</p>
        </div>
    </Tooltip>;
}

export default TotalAttendees;